import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8186a0b8")

_pushScopeId("data-v-8186a0b8")
const _hoisted_1 = {
  style: {"width":"42rem","max-width":"80vw"},
  class: "relative pt-6 edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 text-black-lp-300" }
const _hoisted_3 = { class: "flex flex-col gap-y-2 md:gap-y-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-semibold" }, "Detail Rekening Pengirim", -1)
const _hoisted_5 = { class: "flex flex-col gap-y-2 md:gap-y-6" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-16px font-semibold" }, "Detail Rekening Penerima", -1)
const _hoisted_7 = {
  key: 0,
  class: "text-gray-lp-500 text-center w-full"
}
const _hoisted_8 = { class: "w-full flex flex-row justify-center md:justify-end pt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_upload_file = _resolveComponent("upload-file")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showTopupUploadForm,
      persistent: true,
      title: "Upload Bukti Transfer",
      class: "topup-manual-form",
      "onUpdate:modelValue": _cache[11] || (_cache[11] = 
      () => {
        _ctx.showModalFormTopup(false);
        _ctx.showCloseConfirmModal = true;
      }
    )
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_data_wrapper, { label: "Nama Bank" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "Masukan nama bank",
                    modelValue: _ctx.form.fromBankName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.fromBankName = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "Nama Rekening" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "Masukan nama rekening",
                    modelValue: _ctx.form.fromBankAccountName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.fromBankAccountName = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "No. Rekening" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "Masukan No. rekening ",
                    modelValue: _ctx.form.fromBankNumber,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.fromBankNumber = $event)),
                    format: _ctx.formatNumber
                  }, null, 8, ["modelValue", "format"])
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, {
                label: "Jumlah Topup",
                class: "col-span-1"
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "e.g 100.000",
                    prefix: _ctx.currencyPrefix,
                    modelValue: _ctx.form.amount,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.amount = $event)),
                    format: _ctx.formatTopupAmount
                  }, null, 8, ["prefix", "modelValue", "format"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_data_wrapper, {
                label: "Nama Bank",
                class: "mb-2.5"
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomDropdown, {
                    options: _ctx.optionBankTo,
                    onSelect: _ctx.selectBankTo,
                    selectedItem: _ctx.form.toBankName,
                    "onUpdate:selectedItem": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.toBankName = $event)),
                    placeholder: "Pilih bank",
                    class: "w-full mt-1.5"
                  }, {
                    default: _withId(() => [
                      (_ctx.optionBankTo.length === 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, " Data tidak ditemukan "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["options", "onSelect", "selectedItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "Nama Rekening" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "Masukan nama rekening",
                    modelValue: _ctx.form.toBankAccountName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.toBankAccountName = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_data_wrapper, { label: "No. Rekening" }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: "Masukan No. rekening ",
                    modelValue: _ctx.form.toBankNumber,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.toBankNumber = $event)),
                    format: _ctx.formatNumber
                  }, null, 8, ["modelValue", "format"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_data_wrapper, {
              label: "Bukti Transfer",
              class: "md:col-span-2"
            }, {
              default: _withId(() => [
                _createVNode(_component_upload_file, {
                  modelValue: _ctx.form.attachment,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.attachment = $event)),
                  type: "",
                  allowed: ".pdf, image/jpeg, image/jpg, image/png",
                  caption: ".jpg/.jpeg/.png/.pdf",
                  showPreviewImage: "",
                  maxSize: 2
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_button_fill, {
              onClick: _cache[9] || (_cache[9] = 
            () => {
              _ctx.showModalFormTopup(false);
              _ctx.showCloseConfirmModal = true;
            }
          ),
              title: "Kembali",
              class: "text-red-lp-300 border border-red-lp-300 mr-5",
              style: {"background-color":"#fff","width":"135px"}
            }),
            _createVNode(_component_button_fill, {
              isDisabled: !_ctx.isFormValid,
              onClick: _cache[10] || (_cache[10] = 
            () => {
              if (!_ctx.isLoading && _ctx.isFormValid) {
                _ctx.showModalFormTopup(false);
                _ctx.showConfirmModal = true;
              }
            }
          ),
              title: "Upload",
              class: "bg-red-lp-300",
              style: {"width":"135px"},
              isLoading: _ctx.isLoading
            }, null, 8, ["isDisabled", "isLoading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.onSubmit(),
      onClose: 
      () => {
        _ctx.showModalFormTopup(true);
        _ctx.showConfirmModal = false;
      }
    ,
      title: "Konfirmasi Pengunggahan",
      message: 
      `Anda yakin ingin mengunggah bukti transfer dengan jumlah ${this.currencyPrefix}. ${_ctx.form?.amount} ?`
    ,
      image: "are-you-sure",
      textSuccess: "Upload",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.resetForm();
        _ctx.setSuccessSubmit(false);
      }
    ,
      title: "Pengunggahan Berhasil !",
      message: 
      `Bukti transfer berhasil diunggah. Mohon<br />menunggu sampai transaksi top up diverifikasi &<br />disetujui oleh Internal. `
    ,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isSuccessSubmit]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.resetForm,
      onClose: 
      () => {
        _ctx.showCloseConfirmModal = false;
        _ctx.showModalFormTopup(true);
      }
    ,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.showCloseConfirmModal]
    ])
  ], 64))
})